import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <main className="max-w-md mx-auto px-6 py-16">
      <p className="label-overline text-center">A letter of restoration</p>
      <h1 className="font-display text-5xl text-center mt-3 mb-2">Forgot Password</h1>
      <div className="fleuron mb-8">❦</div>

      {done ? (
        <div className="parchment-card text-center" data-testid="forgot-success">
          <p className="font-display italic text-2xl">A letter is on its way.</p>
          <p className="font-body text-ink-iron mt-3">If that email exists in our records, a reset link has been dispatched.</p>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="parchment-card space-y-5" data-testid="forgot-form">
          <div>
            <label className="label-overline block mb-2">Email</label>
            <input data-testid="forgot-email" className="field" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          {error && <p className="text-wax-red text-sm italic">{error}</p>}
          <button data-testid="forgot-submit" className="wax-button w-full">Send the letter</button>
        </form>
      )}
    </main>
  );
}
